import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGold, errMsg, inp, lbl } from "./ui";

export default function OrgSettings({ org, types, onSaved }) {
  const [f, setF] = useState({ org_name: org.name, org_type: org.org_type, address: org.address || "", authority_email: org.authority_email });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { onSaved((await api.put("/attendance/org", f)).data); toast.success("Organisation updated"); }
    catch (err) { toast.error(errMsg(err, "Save failed")); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="grid sm:grid-cols-2 gap-4 max-w-3xl" data-testid="att-org-settings">
      <div><label className={lbl}>Organisation name</label><input required data-testid="att-set-name" className={inp} value={f.org_name} onChange={set("org_name")} /></div>
      <div><label className={lbl}>Type</label><select className={inp} data-testid="att-set-type" value={f.org_type} onChange={set("org_type")}>{types.map((t) => <option key={t}>{t}</option>)}</select></div>
      <div className="sm:col-span-2"><label className={lbl}>Address</label><input className={inp} data-testid="att-set-address" value={f.address} onChange={set("address")} /></div>
      <div className="sm:col-span-2"><label className={lbl}>Report recipient email</label><input required type="email" data-testid="att-set-authority" className={inp} value={f.authority_email} onChange={set("authority_email")} /></div>
      <div className="sm:col-span-2 text-xs text-neutral-500 leading-relaxed">
        Data & privacy: we store only event details, attendance counts, usher names and emails, and an audit trail of changes. Your data is never shared with other organisations.
        If your subscription ends, your history and reports stay available read-only for 24 months, after which they may be deleted. Email hanson@hohvibes.com to request export or deletion at any time.
      </div>
      <button disabled={busy} data-testid="att-set-save" className={`${btnGold} sm:col-span-2 sm:w-fit`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save</button>
    </form>
  );
}
